<template>
    <div class="full-page-container">

        <q-dialog class="rounded-brders" v-model="dialogNuevo" persistent>
            <q-card class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nuevo Usuario</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-md">
                        <div class="col-12">
                            <q-input dense outlined v-model="form.nombre" label="Nombre(s)" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.apellidos" label="Apellidos" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.email" label="Correo electrónico" type="email" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.telefono" mask="(###) ### - ####" label="Teléfono" />
                        </div>
                        <div class="col-12">
                            <q-input v-model="form.password" dense outlined :type="isPwd ? 'password' : 'text'"
                                label="Contraseña">
                                <template v-slot:append>
                                    <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                                        @click="isPwd = !isPwd" />
                                </template>
                            </q-input>
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat label="Guardar" color="primary" @click="guardarDatos()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogCodigo" persistent transition-show="flip-down" transition-hide="flip-up">
            <q-card class="bg-primary text-white">
                <q-bar>
                    <div>Código de Verificación</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip content-class="bg-white text-primary">Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section v-if="codigoRecibido == false" class="q-py-xl">
                    <q-input style="width: 500px;" filled dark color="white" class="text-white" v-model="correoUsuario"
                        type="usuario" label="Correo del Usuario" />
                </q-card-section>
                <q-card-section v-if="codigoRecibido == true && usuaioCambio == null" class="q-py-xl">
                    <div class="row justify-center q-gutter-sm">
                        <q-input v-for="(char, index) in code" :key="index" v-model="code[index]" filled maxlength="1"
                            class="code-input text-white" @input="focusNext(index, $event)"
                            @keydown.backspace="focusPrev(index, $event)" ref="inputs" label-color="white" dark
                            color="white" />
                    </div>
                </q-card-section>
                <q-card-section v-if="usuaioCambio != null" class="q-py-xl">
                    <div class="row justify-center q-gutter-sm">
                        <q-input filled label-color="white" style="width: 250px;" color="white" class="text-white"
                            v-model="nuevaContraseña" label="Contraseña" dark :type="isPwd ? 'password' : 'text'">
                            <template v-slot:append>
                                <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye-outline'" class="cursor-pointer"
                                    @click="isPwd = !isPwd" />
                            </template>
                        </q-input>
                    </div>
                </q-card-section>

                <q-card-actions v-if="codigoRecibido == false" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="enviarCodigo()"
                            label="ENVIAR CÓDIGO" />
                    </template>
                </q-card-actions>

                <q-card-actions v-if="codigoRecibido == true && usuaioCambio == null" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="validarCodigo()"
                            label="VALIDAR CODIGO" />
                    </template>
                </q-card-actions>

                <q-card-actions v-if="usuaioCambio != null" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="actualizarContraseña()"
                            label="ACTUALIZAR CONTRASEÑA" />
                    </template>
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="main-content row no-wrap">
            <div class="col-12 col-md-8 bg-image-column flex flex-center gt-sm"
                :style="{ backgroundImage: 'url(' + backgroundImageUrl + ')' }">
                <div class="image-overlay">
                    <div class="text-white text-h4 text-center q-pa-md">

                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 flex flex-center q-pa-md" style="background-color: #F3F6F5;">
                <div v-if="formlogin" class="full-width" style="max-width: 400px;">
                    <q-card class="shadow-0 transparent text-center">
                        <q-card-section>
                            <div class="create-account text-h5 text-primary">Iniciar Sesión</div>
                        </q-card-section>
                        <q-card-section class="q-pa-none">
                            <!-- <q-form class="q-gutter-md" @submit.prevent="validaUsuarioYPassword"> -->
                            <q-input dense bg-color="white" filled color="primary" v-model="nombreU" label="Correo"
                                type="email" class="border-orange" />
                            <q-input dense bg-color="white" filled color="primary" v-model="passwordU"
                                @keyup.enter="validaUsuarioYPassword()" :type="isPwd ? 'password' : 'text'"
                                label="Contraseña" class="border-orange q-mt-lg">
                                <template v-slot:append>
                                    <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye-outline'"
                                        class=" full-width cursor-pointer" @click="isPwd = !isPwd" />
                                </template>
                            </q-input>
                            <!-- </q-form> -->
                        </q-card-section>

                        <q-card-actions class="q-pa-none q-mt-lg">
                            <q-btn unelevated class="full-width login-button " @click="validaUsuarioYPassword()"
                                label="Validar acceso" />

                            <q-btn flat color="grey-7" class="full-width q-my-md" label="Olvidé mi Contraseña"
                                @click="cambiarContreseña()" />

                            <q-btn unelevated class="full-width login-button " @click="dialogNuevo = true"
                                label="Registrarse" />
                        </q-card-actions>
                    </q-card>
                </div>
            </div>
        </div>

        <div class="footer-bar">
            <div class="text-white text-center q-py-xs">
                &copy; {{ currentYear }} ArrendaFit | Contago. Todos los derechos reservados.
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex'
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
export default {
    data() {
        return {
            formlogin: true,

            passwordU: '',
            nombreU: "",
            isPwd: true,
            dialogCodigo: false,
            correoUsuario: '',
            code: Array(8).fill(""),

            codigoRecibido: false,
            usuaioCambio: null,
            nuevaContraseña: '',
            backgroundImageUrl: require('../../assets/cotiza.jpg'),
            form: {
                _id: '',
                password: '',
                email: '',
                nombre: '',
                apellidos: '',
                estatus: 'Vigente',
                telefono: '',
                rol: 'Usuario',
                fechaCreacion: '',
                FotoPerfilBase64: 'https://cdn.quasar.dev/img/boy-avatar.png',
            },
            dialogNuevo: false
        };
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'usuario']),

        currentYear() {
            return new Date().getFullYear();
        }
    },
    created() {
    },

    methods: {
        async guardarDatos() {
            console.log(this.form)
            if (this.form.nombre == '' || this.form.apellidos == '' || this.form.password == '' || this.form.email == '' || this.form.password == '') {
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese los datos faltantes.' })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })

            this.form.fechaCreacion = moment().format('YYYY/MM/DD')
            try {
                await axios.post('Login/PostRegistroNuevo/', this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Usuario nuevo registrado.' })
                this.dialogNuevo = false

                this.nombreU = this.form.email
                this.passwordU = this.form.password
                await this.validaUsuarioYPassword();

            } catch (err) {
                console.log(err)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: err.data })
            }
        },

        // MANDAMOS A VALIDAR QUE EXITAN Y QUE ESTE CORRECTO LOS DATOS DEL USUARIO
        async validaUsuarioYPassword() {
            const nombre = this.nombreU;
            const password = this.passwordU
            if (nombre == '') {
                this.$q.notify({ type: 'info', icon: 'mdi-information', message: 'Ingrese un nombre de usuario.', timeout: 2000 })
                return
            }
            if (password == '') {
                this.$q.notify({ type: 'info', icon: 'mdi-information', message: 'Ingrese su contraseña.', timeout: 2000 })
                return
            }

            this.$q.loading.show({ message: '<b>Validando datos...</b>' })
            try {
                let response = await axios.get(`Login/ValidaUsuarioAsync/${nombre}/${password}`);
                console.log(response.data)
                const { token, usuario } = response.data;

                this.$store.dispatch('auth/guardarToken', token)
                this.$store.dispatch('auth/guardarUsuario', usuario)

                if (usuario.rol === 'Administrador') {
                    this.$router.push({ name: 'adminDashboard' });
                } else if (usuario.rol === 'Usuario') {
                    this.$router.push({ name: 'userDashboard' });
                } else {
                    // Opcional: si rol desconocido, redirigir a home o mostrar error
                    this.$router.push({ name: 'login' });
                }

                this.nombreU = "";
                this.password = "";
                this.$q.loading.hide();
            } catch (error) {
                console.log(error)
                this.$q.loading.hide();
                this.$q.notify({ type: 'negative', message: error.response.data });
            }
        },

        cambiarContreseña() {
            this.codigoRecibido = false
            this.nuevaContraseña = ''
            this.usuaioCambio = null
            this.dialogCodigo = true
        },

        async enviarCodigo() {
            if (this.correoUsuario == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el correo electrónico registrado.' })
                return;
            }
            let objeto = {
                _id: '',
                _id_usuario: '',
                codigo: '',
                estatus: 'PENDIENTE',
                fechaCambio: moment().format('YYYY-MM-DD HH:mm:ss'),
                correo: this.correoUsuario
            }
            try {
                let response = await axios.post(`Login/PostCambioContraseña/`, objeto)
                console.log(response)
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Código enviado al correo.', color: 'green' })
                this.codigoRecibido = true
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
            }
        },

        async validarCodigo() {

            if (this.code == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el código de verificación.' })
                return;
            }
            let codigo = this.code.join('')
            try {
                let response = await axios.get('Login/GetValidaCodigo/' + this.correoUsuario + '/' + codigo)
                console.log(response)
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Código correcto.', color: 'green' })

                this.usuaioCambio = response.data

            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
                this.usuaioCambio = null

            }
        },

        async actualizarContraseña() {

            let objeto = {
                _id_usuario: this.usuaioCambio._id,
                codigo: this.code.join(''),
                correo: this.correoUsuario,
                pass: this.nuevaContraseña,
                fechaCambio: moment().format('YYYY-MM-DD HH:mm:ss'),
                estatus: "REALIZADO"
            }

            try {
                let response = await axios.put('Login/PutPassword/', objeto)
                console.log(response)
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Contraseña actualizada.', color: 'green' })

                this.codigoRecibido = false
                this.nuevaContraseña = ''
                this.usuaioCambio = null
                this.dialogCodigo = false


            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
            }
        },

        CancelarInicio() {
            this.formlogin = true
            this.estado = {}
            this.passwordU = ''
            this.nombreU = ""
        },

        focusNext(index, event) {
            if (event && event.length === 1 && index < this.code.length - 1) {
                this.$refs.inputs[index + 1].focus();
            }
        },

        focusPrev(index, event) {
            if (!this.code[index] && index > 0) {
                this.$refs.inputs[index - 1].focus();
            }
        },

    }
};
</script>
<style scoped>
.code-input {
    width: 40px;
    text-align: center;
}

.full-page-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    /* Asegura que ocupe al menos el 100% del alto del viewport */
}

.main-content {
    flex: 1;
    /* Ocupa todo el espacio disponible verticalmente */
    display: flex;
    height: 100%;
    /* Asegura que las columnas internas puedan usar height: 100% */
}

.full-height {
    height: 100%;
    /* Ahora sí funcionará correctamente dentro de main-content */
}

.bg-image-column {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    /* Necesario para posicionar el overlay */
}

/* Overlay para oscurecer la imagen y mejorar la legibilidad del texto */
.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    /* Negro con 40% de opacidad */
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer-bar {
    /* Mantienes tu estilo de footer */
    height: 40px;
    /* Un poco más de altura para el texto del copyright */
    background-color: #233746;
    /* Tu color naranja */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Estilos específicos del formulario */
.create-account {
    font-weight: bold;
    font-size: 1.8rem;
    color: #233746;
    /* Quasar por defecto para 'orange' */
    margin-bottom: 20px;
}

.border-orange .q-field__control:after,
.border-orange .q-field__control:before {
    border-color: #233746 !important;
    /* Asegura que el borde del input sea naranja */
}

.login-button {
    background-color: #233746;
    /* Color naranja */
    color: white;
    font-weight: bold;
}
</style>